import React, { useContext, useEffect, useState } from "react"
import { Preguntas } from "../components/Preguntas"
import { Box, Container, Typography, Grid, Stack } from "@mui/material"
import { LinearProgress } from "@mui/material"
import { Button } from "@mui/material"
import { HelpTemas } from "../components/HelpTemas"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import { useTranslation } from "react-i18next"
import { useSecurity } from "../hooks/useSecurity"
import { CuestionSkeleton } from "../components/commons/CuestionSkeleton"
import { GeneralContext } from '../context/GeneralContext'
import { CuestionContext } from "../context/CuestionContext"
import { DobleCircularProgressWithLabel } from "../components/commons/DobleCircularProgressWithLabel"
import Modal from "../components/commons/Modal";
import ModalConfirmar from '../components/commons/ModalConfirmar'

export const Cuestion = () => {
    const {
        cuestion,
        PreguntaRespondida,
        PreguntaAnterior,
        RespuestaSeleccionada,
        backToAxes,
        navigate,
        anularEje,
        user
    } = useContext(CuestionContext);

    const { questionaryPercentage } = useContext(GeneralContext)
    const [showMaxNoAplica, setShowMaxNoAplica] = useState(true);
    const { t } = useTranslation()
    useSecurity()

    useEffect(() => {
        //if (cuestion?.ultimaCuestion)
        //navigate("/Ejes");
        setShowMaxNoAplica(true);
    }, [cuestion]);

    return (
        <Container>
            {cuestion ? (
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid item sx={{ width: '100%' }}>
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            justifyContent="space-between"
                            alignItems="center"
                            spacing={2}
                            sx={{ height: '100px', marginTop: '1em', paddingBottom: '1em' }}
                        >
                            <Button
                                variant="contained"
                                startIcon={<FirstPageIcon icon={FirstPageIcon} />}
                                onClick={backToAxes}
                            >
                                {t("cuestion.btnVolver")}
                            </Button>
                            <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                            >
                                <Typography variant="body2" color="text.blue" sx={{ fontWeight: 'bold', fontSize: '1em' }}>
                                    {t("general.porcentajeTotal")}
                                </Typography>
                                <DobleCircularProgressWithLabel percentage={questionaryPercentage} size={60} fontSize={"1em"} />
                            </Stack>
                        </Stack>

                        <Box>
                            <Typography variant="h6" color="text.black">
                                {cuestion?.pregunta?.tema?.texto ? t("cuestion.ejeTitulo") + cuestion.pregunta.tema.texto : ""}
                            </Typography>
                        </Box>

                        {/* linea progreso cuestionario */}
                        <Box
                            sx={{ display: "flex", alignItems: "center", textAlign: "end" }}
                        >
                            <Box sx={{ width: "100%" }}>
                                <LinearProgress
                                    variant="determinate"
                                    value={cuestion.porcentajeTema}
                                />
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                                <Typography variant="body2" color="text.blue">
                                    {cuestion.porcentajeTema}%
                                </Typography>
                            </Box>
                        </Box>
                        {/* Preguntas del cuestionario */}
                        <Stack
                            direction={{ xs: 'column', sm: 'column', md: 'row' }}
                            justifyContent="space-evenly"
                            spacing={2}
                            sx={{
                                paddingTop: '2em',

                            }}
                        >
                            <Box sx={{ flexBasis: cuestion?.pregunta?.texto_ayuda?.length > 0 ? '65%' : '100%' }}>
                                <Preguntas pregunta={cuestion.pregunta} />
                                <Stack direction="row" spacing={2}>
                                    <Button
                                        disabled={cuestion.porcentajeTema == 0 && true}
                                        onClick={() => {
                                            PreguntaAnterior(cuestion.pregunta);
                                        }}
                                        variant="contained"
                                    >
                                        {t("cuestion.btnAnterior")}
                                    </Button>
                                    {/* Boton siguiente pregunta */}
                                    <Button
                                        disabled={!RespuestaSeleccionada}
                                        variant="contained"
                                        onClick={() => {
                                            PreguntaRespondida(RespuestaSeleccionada);
                                        }}
                                    >
                                        {t("cuestion.btnSiguiente")}
                                    </Button>
                                </Stack>
                            </Box>
                            <Box textAlign={"justify"} sx={{ flexBasis: cuestion?.pregunta?.texto_ayuda?.length > 0 ? '35%' : '0%', display: cuestion.ultimaCuestion && "none" }}>
                                <HelpTemas texto={cuestion?.pregunta?.texto_ayuda} />
                            </Box>
                        </Stack>
                    </Grid>
                    {cuestion?.maxNoAplica &&
                        <Modal title={t("cuestion.tituloMaxNoAplica")} content={t("cuestion.textoMaxNoAplica")} open={showMaxNoAplica}  >
                            <ModalConfirmar
                                title={t("eje.desactivarEjePregunta")}
                                text={t("eje.desactivarEjeBody")}
                                cancelText={t("general.cancelar")}
                                continueText={t("general.aceptar")}
                                onContinue={() => { anularEje(user, cuestion.pregunta.id_tema).then(() => navigate("/Ejes")) }} >
                                <Button>{t("cuestion.anularEje")}</Button>
                            </ModalConfirmar>
                            <Button variant="contained" onClick={() => { setShowMaxNoAplica(false) }} >{t("cuestion.cambiarRespuesta")}</Button>
                        </Modal>
                    }
                </Grid>
            ) : (
                <CuestionSkeleton />
            )}
        </Container>
    )
}
